import { cn } from '@/platform/lib/utils';
import TableCell from './TableCell';
import TableRow from './TableRow';

const TablePlaceholderRow = ({ colSpan, className, ...props }) => (
    <TableRow
        aria-hidden='true'
        className={cn('animate-pulse [animation-duration:1.5s]', className)}
        {...props}
    >
        <TableCell colSpan={colSpan}>
            <div className='h-3 rounded bg-gray-200' />
        </TableCell>
    </TableRow>
);

export default TablePlaceholderRow;
